export class UploadFileTransactionDataResultList {

    public cmaCarrierCode: string;
    public cmaLoadId: string;
    public excelCarrierCode: string;
    public excelLoadId: string;
    public note: string;
    public loadedMiles: string;
    public emptyMiles: string;
    public totalCharges: string;
    public status: string;
    public btfStatus: string;


    static fromDto(data: any): UploadFileTransactionDataResultList {
        if (!data) {
          return null;
        }

        const resultList = new UploadFileTransactionDataResultList();

        resultList.cmaCarrierCode   = data.cmaCarrierCode;
        resultList.cmaLoadId = data.cmaLoadId;
        resultList.excelCarrierCode    = data.excelCarrierCode;
        resultList.excelLoadId      = data.excelLoadId;
        resultList.note     = data.note;
        resultList.loadedMiles     = data.loadedMiles;
        resultList.emptyMiles     = data.emptyMiles;
        resultList.totalCharges     = data.totalCharges;
        resultList.status = data.status;
        resultList.btfStatus = data.btfStatus;

        return resultList;
      }

      static toDtos(data: UploadFileTransactionDataResultList[]) {
        return data.map(d => ({
            cmaCarrierCode: d.cmaCarrierCode,
            cmaLoadId: d.cmaLoadId,
            excelCarrierCode: d.excelCarrierCode,
            excelLoadId: d.excelLoadId,
            note: d.note,
            totalCharges: d.totalCharges,
            status: d.status
        }));
      }

}
